import { makeSubmitEditableTableChanges } from "api/makeApiRequestType/makeSubmitEditableTableChanges";
import { OutputRow as ExternalCommitmentsData } from "api/getExternalCommitments";

export const saveExternalCommitments = makeSubmitEditableTableChanges<
	ExternalCommitmentsData
>("externalCommitments");
